import React from 'react';

import Text from '@/common/components/text';

export default function AddressRow({ value }: { value: string }) {
  return (
    <div className="flex w-full items-start gap-3 rounded-md bg-gray-30 p-3">
      <Text className="shrink-0 text-sm font-medium text-gray-700">آدرس:</Text>
      <div className="min-w-0 flex-1">
        <Text className="break-words text-left text-sm font-medium leading-relaxed text-gray-700">
          {value}
        </Text>
      </div>
    </div>
  );
}
